module.exports = __webpack_public_path__ + "img/u297.db473adb.svg";